import React from 'react'
import PartnerModal from '../../../../components/common/form/modal/PartnerModal'


const PartnerModalConatiner = ({ link, title, open, handleClose, selectedPartner }) => {
    return (
        <PartnerModal
            link={link}
            title={title}
            open={open}
            handleClose={handleClose}
            selectedPartner={selectedPartner}
        />
    )
}

export default PartnerModalConatiner